import * as CHQ from "chq";
import { DefaultProfile } from "./context/ProfileContext";
import { COMPANIES_TABLE, SKILLS_TABLE } from "./utils/constants";

export const canAdminComment = (profile: CHQ.Profile, comment: CHQ.Comment) => (
  profile.organizationAdmin || (profile.id === comment.user.id)
);

export const canAdminPost = (profile: CHQ.Profile, post: CHQ.Post) => (
  profile.organizationAdmin || (profile.id === post.creator.id)
);

export const isCulturalAmbassadorAndCreator = (profile: CHQ.Profile, story: CHQ.Story) => (
  isCulturalAmbassador(profile) && profile.id === story.creator.id
);

export const canShareStory = (profile: CHQ.Profile, story: CHQ.Story) => (
  profile.id === story.creator.id && (isCulturalAmbassador(profile) || story.approvedForSocial)
);

export const canAdminSocialShare = (profile: CHQ.Profile, post: CHQ.SocialShare) => (
  profile.organizationAdmin || (profile.id === post.creator.id)
);

export const canAdminStory = (profile: CHQ.Profile, story: CHQ.Story) => (
  profile.organizationAdmin || (profile.id === story.creator.id)
);

export const canAdminEndorsement = (profile: CHQ.Profile, endorsement: CHQ.Endorsement) => (
  profile.organizationAdmin || (profile.id === endorsement.creator.id)
);

export const canAdminRecognition = (profile: CHQ.Profile, recognition: CHQ.Recognition) => {
  const creatorId = (recognition.creator || {}).id;

  return profile.organizationAdmin || (profile.id === creatorId);
};

export const canApproveRecognition = (profile: CHQ.Profile, recognition: CHQ.Recognition) => (
  profile.organizationAdmin && !recognition.approved
);

export const canAdminSurveys = (profile: CHQ.Profile) => (
  profile.organizationAdmin || profile.organization.userCreatedSurveysEnabled
);

export const canCreateEvent = (profile: CHQ.Profile) => (
  profile.organizationAdmin || profile.organization.userCreatedEventsEnabled
);

export const canPinUserActivity = (profile: CHQ.Profile) => (
  profile.organizationAdmin
);

export const canViewSurveyResults = (profile: CHQ.Profile, survey: CHQ.SurveyWithStatus) => (
  profile.organizationAdmin
  || (survey.creator.id === profile.id)
  || (survey.statusForUser === "complete" && survey.viewableResults)
);

export const canViewLandingPage = (
  profile: CHQ.Profile | DefaultProfile
) => (profile.organization.employerBranding);

export const isCulturalAmbassador = (profile: CHQ.Profile) => (
  isAdmin(profile) || profile.role === "cultural_ambassador"
);

export const isAdmin = (profile: CHQ.Profile) => (
  profile.organizationAdmin || profile.role === "content_admin"
);

export const isMyOwnStory = (profile: CHQ.Profile, story: CHQ.Story) => (
  profile.id === story.creator.id
);

export const isSuperAdmin = (profile: CHQ.Profile) => (
  profile.organizationAdmin
);

export const canViewCompaniesField = (organization: CHQ.Organization) => (
  (organization.organizationFields
    ?.filter(field => field.table === COMPANIES_TABLE) || []).length > 0
);

export const canViewSkillsField = (organization: CHQ.Organization) => (
  (organization.organizationFields
    ?.filter(field => field.table === SKILLS_TABLE) || []).length > 0
);

export const canViewCompaniesFieldLandingPage = (organization: string) => (
  organization === "activisionblizzard" || organization === "activision blizzard" || organization === "demo"
    || organization === "centrica"
);
